import React, { useEffect, useState, useRef } from "react";
import { Box, IconButton, Modal } from "@mui/material";
import { Link } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import { useMediaQuery } from "react-responsive";
import { COLORS } from "../../constants";

const TradeShowModal = () => {
  const isMobile = useMediaQuery({ query: "(max-width: 600px)" });
  const modalRef = useRef(null);
  const [open, setOpen] = useState(false);

  // Date and caching logic
  const TRADE_SHOW_END_DATE = new Date("2025-10-22T23:59:59");
  const CACHE_KEY = "tradeShowModalClosed";
  const ONE_DAY_MS = 24 * 60 * 60 * 1000;

  const shouldShowModal = () => {
    const now = new Date();
    if (now > TRADE_SHOW_END_DATE) {
      return false; // Don't show after October 22, 2025
    }

    const closedData = localStorage.getItem(CACHE_KEY);
    if (!closedData) {
      return true; // No cache, show modal
    }

    const { closedDate } = JSON.parse(closedData);
    const closedTime = new Date(closedDate).getTime();
    const timeDiff = now.getTime() - closedTime;

    // Show modal if it was closed more than a day ago
    return timeDiff > ONE_DAY_MS;
  };

  const handleClose = () => {
    setOpen(false);
    localStorage.setItem(
      CACHE_KEY,
      JSON.stringify({ closedDate: new Date().toISOString() }),
    );
  };

  // Handle click outside to close the modal
  const handleClickOutside = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      handleClose();
    }
  };

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: isMobile ? "90%" : "60%",
    maxWidth: "800px",
    bgcolor: "transparent",
    boxShadow: 24,
    borderRadius: 2,
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
  };

  const imageContainerStyle = {
    width: "100%",
    borderRadius: 2,
    overflow: "hidden",
  };

  // Check if modal should open when component mounts
  useEffect(() => {
    if (shouldShowModal()) {
      setOpen(true);
    }
  }, []);

  return (
    <Modal
      open={open}
      onClose={handleClose}
      disableEscapeKeyDown={false}
      onClick={handleClickOutside}
    >
      <Box>
        <IconButton
          onClick={handleClose}
          sx={{
            position: "fixed",
            top: 8,
            right: 8,
            color: COLORS.white,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.7)" },
            zIndex: 1500, // Adjusted to ensure visibility
          }}
          aria-label="Close trade show modal"
        >
          <CloseIcon />
        </IconButton>
        <Box sx={modalStyle} ref={modalRef}>
          <Box sx={imageContainerStyle}>
            <Link
              to="/tradeshow"
              style={{ textDecoration: "none" }}
              aria-label="Go to trade show page"
              onClick={handleClose} // Close modal and update cache on click
            >
              <img
                src="https://argusweb.azureedge.net/argus-web/trade-show/TradeShowBanner.png"
                alt="Trade Show Banner"
                style={{
                  width: "100%",
                  height: "auto",
                  objectFit: "contain",
                  borderRadius: 2,
                  display: "block",
                }}
              />
            </Link>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default TradeShowModal;
